import PropTypes from 'prop-types';
import React from 'react';
import moment from 'moment-timezone';
import SelectFrequency from './SelectFrequency';
import config from '../../../../config';

const RepeatAppointment = ({
  recurrEveryNumDays,
  recurrUntil,
  active,
  disabled,
  onFrequencyChange,
}) => (
  <div className="layout__item u-mt--" display-if={!disabled || active}>
    <div className="c-label-new">Repeat</div>
    <SelectFrequency onChange={onFrequencyChange} disabled={disabled} value={recurrEveryNumDays} />
    <div display-if={disabled && moment(recurrUntil).isValid()}>
      <div className="c-label-new u-mt-">Ends</div>
      <input
        type="text"
        className="c-input"
        value={moment(recurrUntil).format(config.fullDateFormat)}
        disabled={disabled}
      />
    </div>
  </div>
);
RepeatAppointment.propTypes = {
  recurrEveryNumDays: PropTypes.number,
  recurrUntil: PropTypes.string,
  active: PropTypes.bool,
  disabled: PropTypes.bool,
  onFrequencyChange: PropTypes.func,
};
RepeatAppointment.defaultProps = {
  recurrEveryNumDays: -1,
  recurrUntil: '',
  active: false,
  disabled: false,
  onFrequencyChange: () => null,
};

export default RepeatAppointment;
